import React, { useEffect, useState } from 'react'
import { withAuth } from '../AuthContext'
import { withRouter } from 'react-router-dom'
import { loadStripe } from '@stripe/stripe-js'
import { setPayAsYouChoosePricing, getCurrencySign } from '../../utils/utils'
import { shouldTranslateTo } from '../../utils/utils'
import { gaEvents } from '../../analytics/events'
import { SUCCESS } from '../../utils/constants'
import Notification from '../Utils/Notification'
import Error from '../Utils/Error'
import Payment from 'payment'
import Cookies from 'universal-cookie'
import styled from 'styled-components'
import Cards from 'react-credit-cards-2'
import 'react-credit-cards-2/dist/es/styles-compiled.css'

import {
  Title,
  Subtitle,
  Input,
  ActionButtons,
  LoadingButton,
} from '../Utils/CustomClasses'

const stripeKey = window.location.origin.includes('localhost')
  ? 'pk_test_518KDziCpZYiw17LY2MYtYdH9etP4Z0M0sHGKsoHMy7x7uavW3cN8mfpTEgiZPwGSc0rx32ZDCMv9g1E4JJmBCq1S00ASeexo7s'
  : 'pk_live_518KDziCpZYiw17LYRTUhBuTjHhAESPtj5SDtaZNXYYmco9GYuTcuNvErxtdJgzOnSpDaTmZn9xY7pTIwfQiAhipy004T59e1Mj'
const stripePromise = loadStripe(stripeKey)
const cookies = new Cookies()

const ContainerBox = styled.div`
  padding: 30px 36px 55px 36px;
  background-color: #ffffff;

  @media (max-width: 767px) {
    padding: 25px 25px 25px 25px;
  }
`

const PriceTitle = styled(Subtitle)`
  span {
    color: #0bac5d;
    font-family: 'Open Sans', sans-serif;
    font-size: 40px;
    font-weight: 700;
    margin: 0 0 0 4px;
  }
`

const DashLineBox = styled.div`
  margin-top: 50px;
  padding: 30px 15px 40px;
  border-radius: 4px;
  border: 2px dashed #0bac5d;

  form {
    display: flex;
    justify-content: center;
    flex-direction: column;
    flex-wrap: nowrap;
    align-content: center;
    align-items: center;
    gap: 10px;
    text-align: center;
  }

  @media screen and (max-width: 600px) {
    padding: 30px 5px 40px;
  }
`

const SplitRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  & > div {
    flex-basis: 50%;
  }

  @media screen and (max-width: 600px) {
    flex-direction: column;
  }
`

const SplitColumn = styled.div`
  & > h1 {
    margin: 8px 0 0 0;
  }

  @media screen and (max-width: 768px) {
    & > h1 {
      margin: 13px 0 0 0;
    }
  }

  @media screen and (max-width: 600px) {
    text-align: center;
  }
`

const SplitColumnRight = styled(SplitColumn)`
  text-align: right;

  @media screen and (max-width: 600px) {
    text-align: center;
    h2 {
      margin-top: 20px;
    }
  }
`

const FormFields = styled.div`
  width: 80%;
  margin: 30px 0 0 0;
  min-width: 220px;
  max-width: 490px;
  text-align: left;
`

const FeeCards = styled.div`
  @media screen and (max-width: 398px) {
    display: none !important;
  }
`

const FeeActionButton = styled(ActionButtons)`
  display: inline-block;
`

const FeeLoadingButton = styled(LoadingButton)`
  display: inline-flex;
`

const BackButton = styled(ActionButtons)`
  background-color: #fff;
  border: 1px solid #000;
  color: #000;
  display: inline-block;

  @media screen and (max-width: 768px) {
    margin: 10px 0 0;
  }

  @media screen and (min-width: 769px) {
    max-width: 150px;
  }
`

const FeePayAsYouChooseApp = ({ data, onUpdate, onBack }) => {
  const [voucherCode, setVoucherCode] = useState('')
  const [name, setName] = useState('')
  const [number, setNumber] = useState('')
  const [expiry, setExpiry] = useState('')
  const [cvc, setCvc] = useState('')
  const [focused, setFocused] = useState('')
  const [errorText, setErrorText] = useState('')
  const [warningText, setWarningText] = useState('')
  const [numberError, setNumberError] = useState('')
  const [nameError, setNameError] = useState('')
  const [expiryError, setExpiryError] = useState('')
  const [cvcError, setCvcError] = useState('')
  const [loading, setLoading] = useState('')
  const [responseMessage, setResponseMessage] = useState('')
  const [membership, setMembership] = useState({
    membershipFee: null,
    membershipFeeStatus: null,
    feeSlug: '',
  })
  const [currencySign, setCurrencySign] = useState('')
  const [pageText, setPageText] = useState([])

  useEffect(() => {
    gaEvents.eventGeneric(
      'page_load',
      'stripe-page-loaded',
      data.auth.user.id + ' - stripe - page loaded'
    )

    /*
        Payment.formatCardNumber(document.querySelector('[name="number"]'));
        Payment.formatCardExpiry(document.querySelector('[name="expiry"]'));
        Payment.formatCardCVC(document.querySelector('[name="cvc"]'));
        */
    const language = shouldTranslateTo()
    const getPageText = (pageValue, languageValue) => {
      axios
        .get(`/api/page-text/${pageValue}/${languageValue}`)
        .then((response) => {
          let pageText = response.data.map((textItem) => {
            return textItem.text
          })

          setPageText(pageText)
        })
        .catch((err) => {
          console.log('Error getting page text: ', err)
        })
    }

    const getPricing = async () => {
      const membershipData = await setPayAsYouChoosePricing(
        data.auth.user.membershipFee,
        data.auth.user.currencyValue
      )
      setMembership(membershipData)
    }

    const getCurrency = async () => {
      const currencySignData = await getCurrencySign(
        data.auth.user.currencyValue
      )
      setCurrencySign(currencySignData.sign)
    }

    getPageText('pay-as-you-choose-app', language)
    getPricing()
    getCurrency()
  }, [])

  const handleInputChange = ({ target }) => {
    switch (target.name) {
      case 'number':
        const v1 = target.value
          .replace(/\s+/g, '')
          .replace(/[^0-9]/gi, '')
          .substr(0, 16)
        const parts1 = []
        for (let i = 0; i < v1.length; i += 4) {
          parts1.push(v1.substr(i, 4))
        }
        setNumber(parts1.length > 1 ? parts1.join(' ') : target.value)
        break
      case 'expiry':
        const v2 = target.value
          .replace(/\s+/g, '')
          .replace(/[^0-9]/gi, '')
          .substr(0, 4)
        const parts2 = []
        for (let i = 0; i < v2.length; i += 2) {
          parts2.push(v2.substr(i, 2))
        }
        setExpiry(parts2.length > 1 ? parts2.join('/') : target.value)
        break
      case 'name':
        setName(target.value)
        break
      case 'cvc':
        setCvc(target.value)
        break
      case 'voucherCode':
        setVoucherCode(target.value)
        break
    }
  }

  const handleInputFocus = ({ target }) => {
    setFocused(target.name)
  }

  const handleSubmit = () => {
    console.log('handleSubmit')

    gaEvents.eventGeneric(
      'button_click',
      'stripe-payment-actioned',
      data.auth.user.id + ' - Stripe page - button - action Stripe payment'
    )

    setLoading(true)
    setErrorText('')

    const paymentDetails = {
      name: name,
      card_no: number,
      ccExpiryMonth: expiry.slice(0, 2),
      ccExpiryYear: expiry.slice(3, 5),
      cvcNumber: cvc,
      voucherCode: voucherCode,
      feeSlug: membership.feeSlug,
      type: 'annual_membership',
    }

    console.log('paymentDetails: ' + JSON.stringify(paymentDetails))

    const headers = {
      'X-CSRF-TOKEN': window.Laravel.csrfToken,
      'X-Requested-With': 'XMLHttpRequest',
    }

    axios
      .post('/api/payment/stripeIntent', paymentDetails, headers)
      .then((response) => {
        console.log('response: ' + JSON.stringify(response))

        if (!response.data.success) {
          if (response.data.error == 'requires_source_action') {
            console.log('1')
            setWarningText('We are processing your transaction. Please wait...')
            sCP(stripeKey, response.data.clientSecret, this, function (_, err) {
              if (!err.error) {
                setResponseMessage(pageText[15])
                setLoading(false)

                const updatedMembership = {
                  membershipFee: membership.membershipFee,
                  membershipFeeStatus: 'completed',
                  feeSlug: membership.feeSlug,
                }
                setResponseMessage(pageText[17])
                setMembership(updatedMembership)
                data.auth.updateUser(updatedMembership).then(() => {
                  Notification({
                    type: SUCCESS,
                    message: `${pageText[18]}`,
                  })

                  window.scrollTo({
                    top: 0,
                    left: 0,
                    behavior: 'smooth',
                  })

                  setTimeout(function () {
                    onUpdate()
                  }, 1000)

                  setLoading(false)
                })
              } else {
                setErrorText(err.error.message)
                setLoading(false)
              }
            })
          } else {
            console.log('2')
            setErrorText(response.data.error)
            setLoading(false)
          }
        } else {
          setResponseMessage(pageText[16])
          setLoading(false)

          const updatedMembership = {
            membershipFee: membership.membershipFee,
            membershipFeeStatus: 'completed',
            feeSlug: membership.feeSlug,
          }

          setMembership(updatedMembership)
          data.auth.updateUser(updatedMembership).then(() => {
            Notification({
              type: SUCCESS,
              message: `${pageText[18]}`,
            })

            window.scrollTo({
              top: 0,
              left: 0,
              behavior: 'smooth',
            })

            setTimeout(function () {
              onUpdate()
            }, 1000)

            setLoading(false)
          })
        }
      })
      .catch((err) => {
        console.log(err)
        setLoading(false)
      })
  }

  const handleGoBack = (e) => {
    e.preventDefault()
    onBack()
  }

  if (pageText.length === 0) {
    return (
      <div className="card-body text-center">
        <div
          className="spinner-border homestays-spinner"
          style={{ marginTop: '100px' }}
          role="status"
        >
          <span className="sr-only">{pageText[19]}</span>
        </div>
      </div>
    )
  }
  return (
    <ContainerBox>
      <SplitRow>
        <SplitColumn>
          <Title
            size="29px"
            sizemd="29px"
            sizesm="24px"
            dangerouslySetInnerHTML={{
              __html: `${pageText[0]}`,
            }}
          ></Title>
        </SplitColumn>
        <SplitColumnRight>
          <PriceTitle
            size="20px"
            weight="400"
            margin="10px 0 5px"
            dangerouslySetInnerHTML={{
              __html: `${pageText[12]} <span>${currencySign}${data.auth.user.membershipFee}</span>`,
            }}
          />
        </SplitColumnRight>
      </SplitRow>

      <div id="blah"></div>

      <DashLineBox>
        <form
          method="POST"
          action="/"
          name="myForm"
          aria-label="Pay fee"
          onSubmit={(e) => {
            e.preventDefault()
            handleSubmit()
            return false
          }}
        >
          <Subtitle
            size="18px"
            weight="400"
            margin="10px 20vw 5px"
            marginmd="10px 10vw 5px"
            marginsm="10px 5vw 5px"
            dangerouslySetInnerHTML={{
              __html: `${pageText[1]}`,
            }}
          />
          <img
            src="/images/profile/secured-by-stripe.png"
            alt=""
            className="img-secured-by-stripe"
          />
          <FeeCards>
            <Cards
              number={number}
              name={name}
              expiry={expiry}
              cvc={cvc}
              focused={focused}
              locale={{ valid: 'expiry' }}
            />
          </FeeCards>
          <FormFields>
            {' '}
            <Subtitle
              size="22px"
              weight="400"
              margin="10px 0 0"
              dangerouslySetInnerHTML={{
                __html: `${pageText[2]}`,
              }}
            />
            <Input
              id="number"
              type="tel"
              name="number"
              //className={numberError && "error-border"}
              className={'test-class'}
              placeholder="0000 0000 0000 0000"
              value={number}
              required
              margin="0 0 20px 0"
              marginsm="0 0 10px 0"
              onChange={(e) => handleInputChange(e)}
              onFocus={(e) => handleInputFocus(e)}
            />
            <Subtitle
              size="22px"
              weight="400"
              margin="10px 0 0"
              dangerouslySetInnerHTML={{
                __html: `${pageText[3]}`,
              }}
            />
            <Input
              id="name"
              type="text"
              name="name"
              className={nameError && 'error-border'}
              placeholder={pageText[3]}
              required
              margin="0 0 20px 0"
              marginsm="0 0 10px 0"
              onChange={(e) => handleInputChange(e)}
              onFocus={(e) => handleInputFocus(e)}
              value={name}
            />
            <Subtitle
              size="22px"
              weight="400"
              margin="10px 0 0"
              dangerouslySetInnerHTML={{
                __html: `${pageText[4]}`,
              }}
            />
            <Input
              id="expiry"
              type="tel"
              name="expiry"
              value={expiry}
              className={expiryError && 'error-border'}
              placeholder={pageText[5]}
              required
              margin="0 0 20px 0"
              marginsm="0 0 10px 0"
              onChange={(e) => handleInputChange(e)}
              onFocus={(e) => handleInputFocus(e)}
            />
            <Subtitle
              size="22px"
              weight="400"
              margin="10px 0 0"
              dangerouslySetInnerHTML={{
                __html: `${pageText[6]}`,
              }}
            />
            <Input
              id="cvc"
              type="tel"
              name="cvc"
              className={cvcError && 'error-border'}
              placeholder="123"
              required
              margin="0 0 20px 0"
              marginsm="0 0 10px 0"
              onChange={(e) => handleInputChange(e)}
              onFocus={(e) => handleInputFocus(e)}
            />
            <Subtitle
              size="22px"
              weight="400"
              margin="10px 0 0"
              dangerouslySetInnerHTML={{
                __html: `${pageText[7]}`,
              }}
            />
            <Input
              id="voucherCode"
              type="text"
              name="voucherCode"
              placeholder={pageText[13]}
              margin="0 0 20px 0"
              marginsm="0 0 10px 0"
              onChange={(e) => handleInputChange(e)}
              onFocus={(e) => handleInputFocus(e)}
            />
            {loading ? (
              <FeeLoadingButton padding="10px 40px" margin="30px 0 20px">
                {pageText[14]}
              </FeeLoadingButton>
            ) : (
              <FeeActionButton
                type="submit"
                padding="10px 40px"
                margin="30px 0 20px"
              >
                {pageText[10]}
              </FeeActionButton>
            )}
            <BackButton
              type="submit"
              padding="10px 40px"
              margin="30px 0 20px 12px"
              onClick={(e) => {
                handleGoBack(e)
              }}
            >
              {pageText[11]}
            </BackButton>
            {responseMessage && <div>responseMessage</div>}
            {errorText && <Error error={errorText} />}
            <img
              src="/images/profile/secured-by-stripe-only-mini.png"
              alt=""
              className="img-secured-by-stripe-mini-app"
            />
          </FormFields>
        </form>
      </DashLineBox>
    </ContainerBox>
  )
}

export default withRouter(withAuth(FeePayAsYouChooseApp))
